import { type State } from 'src/types';

import {
  getAccountPath,
  getCurrentPathnameFromState,
  getRegisterPath,
  getSettingsPath,
} from './shared';

export function getLogoutPath() {
  return (getAccountPath() + '/sign-out') as `${ReturnType<typeof getAccountPath>}/sign-out`;
}

export function getRegistrationBlockedPath() {
  return (getRegisterPath() + '/not-available') as `${ReturnType<
    typeof getRegisterPath
  >}/not-available`;
}

export function getForgotPasswordPath() {
  return (getAccountPath() + '/help') as `${ReturnType<typeof getAccountPath>}/help`;
}

export function getResetPasswordPath() {
  return (getAccountPath() + '/reset-password') as `${ReturnType<
    typeof getAccountPath
  >}/reset-password`;
}

export function getBillingPath() {
  return (getAccountPath() + '/billing') as `${ReturnType<typeof getAccountPath>}/billing`;
}

export function pathMatchesAccount(pathname: string): boolean {
  const regex = /^\/account.*$/;
  return regex.test(pathname);
}

export function getInfoPath() {
  return (getSettingsPath() + '/info') as `${ReturnType<typeof getSettingsPath>}/info`;
}

export function getDownloadAppPath() {
  return (getSettingsPath() + '/download-app') as `${ReturnType<
    typeof getSettingsPath
  >}/download-app`;
}

export function getSettingsUpgradePath() {
  return (getSettingsPath() + '/upgrade') as `${ReturnType<typeof getSettingsPath>}/upgrade`;
}

export function getManageFamilyPlanPath() {
  return (getSettingsPath() + '/family/manage') as `${ReturnType<
    typeof getSettingsPath
  >}/family/manage`;
}

export function getNotificationsPath() {
  return (getSettingsPath() + '/notices') as `${ReturnType<typeof getSettingsPath>}/notices`;
}

export function getContentSettingsPath() {
  return (getSettingsPath() + '/content') as `${ReturnType<typeof getSettingsPath>}/content`;
}

export function getRedeemPath() {
  return (getSettingsPath() + '/redeem') as `${ReturnType<typeof getSettingsPath>}/redeem`;
}

export function getCodeRedemptionFlowPath(code: string) {
  return `/offer/${code}` as const;
}

export function getProfilePath(webname?: string) {
  if (webname) {
    return `/profile/${webname}` as const;
  }
  return '/profile' as const;
}

export function isProfilePath(path: string): boolean {
  return /^\/profile\/[^/]+$/.test(path);
}

export function getProfileThumbsPath() {
  return (getProfilePath() + '/thumbs') as `${ReturnType<typeof getProfilePath>}/thumbs`;
}

export function isOnSettingsUpgradePage(state: State): boolean {
  const currentPath = getCurrentPathnameFromState(state);
  return currentPath === '/settings/upgrade';
}

export function isDesktopLandingPath(path: string) {
  return path === '/open';
}

export const UserProfilePaths = {
  profilePath: getProfilePath(),
  profileThumbsPath: getProfileThumbsPath(),
};
